import React from "react";
import { Helmet } from "react-helmet-async";

const BASE = "https://www.bewerbung24.ai";
const OG_IMAGE = `${BASE}/og-image.jpg`;

export default function Seo({ title, description, path = "/", jsonLd = null, noindex = false, image = OG_IMAGE }) {
    const url = `${BASE}${path}`;
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
            <link rel="canonical" href={url} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Bewerbung24.ai" />
            <meta property="og:locale" content="de_DE" />
            <meta property="og:image" content={image} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            {jsonLd && (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((j, i) => (
                <script key={i} type="application/ld+json">{JSON.stringify(j)}</script>
            ))}
        </Helmet>
    );
}

export const faqJsonLd = (faq) => ({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faq.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
});

export const breadcrumbJsonLd = (items) => ({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.name, item: `${BASE}${it.path}` })),
});

export const softwareJsonLd = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "Bewerbung24.ai",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    offers: [
        { "@type": "Offer", price: "5.99", priceCurrency: "EUR", description: "1 Bewerbung (Einzelkauf)" },
        { "@type": "Offer", price: "29.99", priceCurrency: "EUR", description: "10er-Paket Bewerbungen" },
        { "@type": "Offer", price: "49.99", priceCurrency: "EUR", description: "20er-Paket Bewerbungen" },
    ],
    description: "KI-gestützte Bewerbungsplattform: Anschreiben, Lebenslauf, Bewerbungsfoto und ATS-Check in Minuten erstellen.",
    url: BASE,
};
